const theme = {
  mediaScreen: {
    desktop: '@media screen and (min-width: 980px)',
    tablet: '@media screen and (max-width: 979px)',
    mobile: '@media screen and (max-width: 500px)',
  },
}

export { theme }
